import {useState} from 'react'
import {useAsyncDebounce} from 'react-table'
import {KTIcon} from '../../_metronic/helpers'

export const GlobalFilter = ({filter, setFilter, ...props}) => {
  const [inputValue, setInputValue] = useState(filter)

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined)
  }, 400)

  return (
    <div className="d-flex align-items-center position-relative my-1 position-relative">
      <KTIcon iconName="magnifier" className="fs-2 position-absolute ms-4 text-dark-emphasis" />
      <input
        type="text"
        className="form-control form-control-solid w-250px ps-12 pe-10 py-2 border border-secondary"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value)
          onChange(e.target.value)
        }}
        {...props}
      />
      {inputValue && (
        <span
          style={{right: '2%', top: '24%'}}
          className="position-absolute text-hover-info"
          type="button"
          onClick={() => {
            setInputValue('')
            setFilter('')
          }}
        >
          <KTIcon iconName="cross-circle" className="fs-1 " />
        </span>
      )}
    </div>
  )
}
